var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 17C34 26.3888 26.3888 34 17 34H6.31429C5.77778 34 5.34286 33.5651 5.34286 33.0286C5.34286 32.4921 5.77778 32.0571 6.31429 32.0571H7.33429C7.60254 32.0571 7.82 31.8397 7.82 31.5714C7.82 31.4173 7.75377 31.2687 7.63626 31.191C3.03507 28.1488 0 22.9289 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM25.2726 11.953C23.6476 9.01954 19.5502 6.26491 14.3059 7.65828C9.65257 8.89465 7.34338 13.4528 7.34339 15.6561C7.34341 18.3637 11.1598 19.2472 15.5177 18.8805C20.3101 18.4773 22.5597 17.3075 26.2529 14.4475C21.4169 17.0556 18.5541 17.7082 14.4495 17.429C12.2216 17.2775 9.1078 16.5079 9.86689 13.0746C10.3298 10.981 12.7127 8.74119 15.9114 8.16196C20.9783 7.24442 24.363 10.8362 25.2726 11.953ZM26.4593 15.0017C27.1562 17.5599 26.414 20.7553 24.3634 23.235C21.5691 26.6139 17.1571 27.4011 13.5704 26.1598C17.2691 25.8134 19.7054 24.597 21.8927 22.7354C21.6221 22.9346 21.3413 23.1247 21.0507 23.3048C17.0248 25.7994 11.6542 25.7452 8.80735 22.4314C11.5175 23.1395 13.69 23.3431 15.9089 22.8664C12.2193 23.0895 8.88919 21.5438 7.28571 18.7764C9.344 20.288 14.0391 21.3685 18.8672 19.9121C22.0639 18.9478 24.6992 17.1959 26.4061 15.1224L26.4004 15.1429C26.4183 15.109 26.436 15.0751 26.4534 15.0412L26.4593 15.0017Z",
    fill: "url(#paint0_linear_1398_3254)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1398_3254",
    x1: 4.93,
    y1: 0.00000161921,
    x2: 38.0348,
    y2: 5.38451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1879FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0658CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoBlue);
export default __webpack_public_path__ + "static/media/app-logo-blue.6f8afdcb9df0c8d75acda4270312d20a.svg";
export { ForwardRef as ReactComponent };